const destinations = [
  {
    name: "Europe & UK",
    context: "Barksdale AFB rotations to RAF Fairford, Mildenhall, and Lakenheath; also casino vendor meetings in London and Amsterdam",
    urgency: "PCS orders and military rotations often arrive with 14–30 days to report",
    icon: "ri-map-pin-2-line",
    flag: "GB",
  },
  {
    name: "Asia & Macau",
    context: "Casino industry training in Macau, Singapore, and Manila; vendor conferences in Hong Kong and Tokyo",
    urgency: "Conference and training dates are fixed — often 3–6 weeks notice",
    icon: "ri-map-pin-2-line",
    flag: "MO",
  },
  {
    name: "Middle East",
    context: "Barksdale AFB deployments to Qatar, UAE, and Kuwait; oil and gas field assignments in Saudi Arabia and Oman",
    urgency: "Deployment orders and field assignments have immovable start dates",
    icon: "ri-map-pin-2-line",
    flag: "QA",
  },
  {
    name: "Mexico & Caribbean",
    context: "Family beach vacations, resort trips, and cruise connections through Dallas or Houston; spring break travel",
    urgency: "Last-minute resort bookings and vacation deals happen 2–4 weeks out",
    icon: "ri-map-pin-2-line",
    flag: "MX",
  },
  {
    name: "Canada",
    context: "Niagara Falls family trips, Toronto business connections, fishing and hunting trips to Alberta and British Columbia",
    urgency: "Summer road trips and outdoor season bookings peak May through August",
    icon: "ri-map-pin-2-line",
    flag: "CA",
  },
  {
    name: "West Africa",
    context: "Oil and gas field assignments in Nigeria, Angola, and Ghana; pipeline inspection in Cameroon and Gabon",
    urgency: "Field rotation dates are fixed — often 2–4 weeks notice",
    icon: "ri-map-pin-2-line",
    flag: "NG",
  },
];

const commonSituations = [
  {
    stat: "65%",
    label: "of Shreveport expedited requests are military-related or discovered within 3 weeks of travel",
  },
  {
    stat: "2–4 Weeks",
    label: "average notice Shreveport travelers have before a planned international trip or deployment",
  },
  {
    stat: "May–Aug",
    label: "peak season when PCS cycles, casino training programs, and family vacation bookings collide",
  },
  {
    stat: "72 Hours",
    label: "shortest deployment turnaround we have accommodated for a Barksdale AFB family",
  },
];

export default function ShreveportDestinationsSection() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Local Travel Intelligence</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Where Shreveport Travelers Go — And Why Passports Get Urgent
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            These are the destinations and travel patterns we see most from Northwest Louisiana clients. Understanding local travel behavior is part of why our document review catches issues before they derail your deployment, casino training, or oil field assignment.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-14">
          {commonSituations.map((s, i) => (
            <div key={i} className="bg-[#1A365D] rounded-lg p-6 text-center">
              <p className="font-serif text-3xl font-bold text-[#F6C344] mb-2">{s.stat}</p>
              <p className="text-white/60 text-xs leading-relaxed">{s.label}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-12">
          {destinations.map((d, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200 hover:border-[#F6C344] transition-all group">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#1A365D]/5 group-hover:bg-[#F6C344]/15 transition-colors flex-shrink-0">
                  <i className={`${d.icon} text-[#1A365D] group-hover:text-[#F6C344] transition-colors text-lg`}></i>
                </div>
                <div>
                  <h3 className="font-bold text-[#1A365D] text-sm">{d.name}</h3>
                </div>
              </div>
              <p className="text-gray-500 text-sm leading-relaxed mb-3">
                {d.context}
              </p>
              <div className="flex items-start gap-2">
                <i className="ri-time-line text-[#F6C344] text-xs flex-shrink-0 mt-0.5"></i>
                <p className="text-gray-400 text-xs leading-relaxed italic">
                  {d.urgency}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#1A365D]/5 flex-shrink-0">
              <i className="ri-links-line text-[#1A365D] text-xl"></i>
            </div>
            <div className="flex-1">
              <h3 className="font-bold text-[#1A365D] text-sm mb-1">Explore Other Louisiana Service Areas</h3>
              <p className="text-gray-500 text-sm leading-relaxed">
                We serve travelers across Louisiana with the same expedited passport processing and document review expertise. Looking for service in another community?
              </p>
            </div>
            <div className="flex flex-wrap gap-2 flex-shrink-0">
              <a href="/new-orleans" className="inline-flex items-center gap-1.5 bg-white hover:bg-[#1A365D] text-[#1A365D] hover:text-white border border-gray-200 hover:border-[#1A365D] font-medium text-xs px-3.5 py-2 rounded-md transition-all whitespace-nowrap">
                New Orleans <i className="ri-arrow-right-line text-xs"></i>
              </a>
              <a href="/baton-rouge" className="inline-flex items-center gap-1.5 bg-white hover:bg-[#1A365D] text-[#1A365D] hover:text-white border border-gray-200 hover:border-[#1A365D] font-medium text-xs px-3.5 py-2 rounded-md transition-all whitespace-nowrap">
                Baton Rouge <i className="ri-arrow-right-line text-xs"></i>
              </a>
              <a href="/states/louisiana" className="inline-flex items-center gap-1.5 bg-white hover:bg-[#1A365D] text-[#1A365D] hover:text-white border border-gray-200 hover:border-[#1A365D] font-medium text-xs px-3.5 py-2 rounded-md transition-all whitespace-nowrap">
                Louisiana <i className="ri-arrow-right-line text-xs"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}